import { List } from '@mui/material';
import { styled } from '@mui/material';
import Link from 'next/link';

export const ListStyled = styled(List)(({ theme }) => ({
  paddingTop: 0,
  paddingLeft: 0,
  marginBottom: theme.spacings.unit(2),
}));
export const LinkStyled = styled(Link)(() => ({}));
